import request from '@/plugins/ecommerce_axios'
import requestAdmin from '@/plugins/admin_axios'

export const GetProductsApi = async () => {
  const response = await requestAdmin.get('/produtos/list/')
  return response.data
}
export const GetProductsEcommerceApi = async (payload) => {
  const response = await request.post(`/produtos/list/ecommerce/`, payload)
  return response.data
}

export const GetProductsAffiliateEcommerceApi = async (affiliate_code, offset = 0, limit = 5) => {
  const response = await request.get(`/produtos/list/ecommerce-afiliado/`, { params: { offset, limit, affiliate_code } })
  return response.data
}

export const GetCategoriasEcommerceApi = async (afiliado_code = false) => {
  const response = await request.get('/produtos/categoria/list/ecommerce/', { params: { afiliado_code } })
  return response.data
}

export const UploadProductImageApi = async (formData) => {
  const response = await requestAdmin.put('/produtos/uploadLogo/', formData)
  return response.data
}


export const SaveProductProtocolType = async (formData) => {
  return await request.post('/produto/protocolType/create/', formData)
}